import React, { useState } from 'react';
import classes from './FinancialInfo.module.css';
import FileHandler from '../../../Shared/FileHandler';
import { useAppContext } from '../../../../Context/AppContext';
import Input from '../../../Shared/Forms/Input';
import { replaceValueForKey } from '../../../../Utility';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Constants, ActivityString } from '../../../../Constants';
import Dropdown from '../../../Shared/Forms/Dropdown';
import cloneDeep from 'lodash.clonedeep';

const FinancialInfo = () => {
  const { transporterInfo, isEditable, navigatigAway } = useAppContext();
  return (
    <div className={classes.container}>
      {Object.keys(transporterInfo).length === 0 ? null : (
        <Content {...transporterInfo} isEditable={isEditable} navigatigAway={navigatigAway} />
      )}
    </div>
  );
};

const Content = ({
  turnover = [],
  navigatigAway,
  net_profit = [],
  owned_fleet,
  associated_fleet,
  isEditable,
  transporter_id,
}) => (
  <>
    <Card
      fy={turnover[turnover.length - 1].financial_year}
      showFy
      title={turnover[turnover.length - 1].unit ? "Turnover" : "Turnover"}
      value={turnover[turnover.length - 1].amount}
      fileId={turnover[turnover.length - 1].balanceSheet}
      isEditable={isEditable}
      editableObj={turnover[turnover.length - 1]}
      blobKey={'balanceSheet'}
      navigatingaway={navigatigAway}
      isValueCurrency
      transporterId={transporter_id}
      fileHandlerTitle="Balance Sheet"
      maxLength={7}
      unit={turnover[turnover.length - 1].unit}
      currency={turnover[turnover.length - 1].currency ?? "₹"}
      currencyName={
        Constants.Currency.find(currencyItem => currencyItem.symbol === turnover?.[turnover.length - 1]?.currency?.trim())?.cc ?? "INR"}
    />
    <Card
      fy={net_profit[net_profit.length - 1].financial_year}
      showFy
      title={net_profit[net_profit.length - 1].unit ? "Net Profit" : "Net Profit"}
      value={net_profit[net_profit.length - 1].amount}
      fileId={net_profit[net_profit.length - 1].pnl_statement}
      isEditable={isEditable}
      editableObj={net_profit[net_profit.length - 1]}
      blobKey={'pnl_statement'}
      navigatingaway={navigatigAway}
      isValueCurrency
      transporterId={transporter_id}
      fileHandlerTitle="PNL Statement"
      maxLength={7}
      unit={net_profit[net_profit.length - 1].unit}
      currency={net_profit[net_profit.length - 1].currency ?? "₹"}
      currencyName={
        Constants.Currency.find(currencyItem => currencyItem.symbol === net_profit?.[net_profit.length - 1]?.currency?.trim())?.cc ?? "INR"}
    />
    <Card
      fy={owned_fleet?.financial_year}
      showFy
      title="Owned Fleet"
      value={owned_fleet.amount}
      fileId={owned_fleet.fleet_list}
      isEditable={isEditable}
      navigatingaway={navigatigAway}
      blobKey={'fleet_list'}
      editableObj={owned_fleet}
      transporterId={transporter_id}
      fileHandlerTitle="Fleet List"
    />
    <Card
      fy={associated_fleet?.financial_year}
      showFy
      title="Associated Fleet"
      value={associated_fleet?.amount}
      fileId={associated_fleet?.associated_list}
      isEditable={isEditable}
      navigatingaway={navigatigAway}
      blobKey={'associated_list'}
      editableObj={associated_fleet ? associated_fleet : 0}
      transporterId={transporter_id}
      fileHandlerTitle="Associated List"
    />
  </>
);

const Card = ({
  fy,
  title,
  value,
  unit,
  fileId,
  isEditable,
  editableObj,
  navigatingaway,
  isValueCurrency,
  transporterId,
  blobKey,
  fileHandlerTitle,
  showFy,
  maxLength=9999999,
  currency,
  currencyName
}) => {
  const [selectedCurrency, setSelectedCurrency] = useState(currency ?? "₹")

  return (
  <div className={classes.card}>
    <div>
      {isEditable ? (
        <Dropdown
          defaultValues={cloneDeep(Constants.FinancialYears).filter(
            a => a.value === fy
          )}
          picklistOptions={cloneDeep(Constants.FinancialYears)}
          onValueChange={selected =>
            replaceValueForKey(editableObj, 'financial_year', selected.value)
          }
          placeholder="Financial Year"
        />
      ) : (
        <div className={classes['fy-info']}>
            <>
            <span>FY:</span>
            <span>{fy}</span>
            </>
        </div>
      )}
    </div>
    <div style={{fontSize: '12px', marginTop: '5%'}}>{title}</div>
    <div style={{fontSize: '14px', display: 'flex'}}>
      {isEditable ? (
          <>
            <span style={{width: '85%'}} className='d-flex'>
              {
                isValueCurrency && 
                <span style={{fontSize:"12px"}}>
                  <Dropdown
                         picklistOptions={Constants.Currency.map(currency => ({
                          label: `${currency.symbol} (${currency.cc})`,
                          value: `${currency.symbol} (${currency.cc})`
                        }))}
                        defaultValues={{
                          label: currencyName !== "" ? `${currency} (${currencyName})` : currency,
                          value: currencyName !== "" ? `${currency} (${currencyName})` : currency
                        }}                        
                        onValueChange={selected =>{
                          replaceValueForKey(editableObj, 'currency', selected.value)
                          setSelectedCurrency(selected.value)
                        }}
                      />
                </span>
              }
              <Input
                defaultValue={value}
                onChange={(value) => replaceValueForKey(editableObj ? editableObj : {}, 'amount', value)}
                className={classes['amt-input']}
                ErrorMessage='Invalid Amount'
                maxLength={maxLength}
                isInvalid={(navigatingaway && !isValid(editableObj?.amount))}
                type="number"
              />
            </span>
            {selectedCurrency.includes("₹") && (title !== "Owned Fleet" || title !== "Associated Fleet") &&
            <span style={{marginTop: '2%'}} className={selectedCurrency.includes("₹") && title !== "Owned Fleet" && title !== "Associated Fleet" ? '' : 'hidden'}>
              <select name={'unit'} style={{width: '100%', marginLeft: '12%'}} defaultValue={unit} onChange={(e) => replaceValueForKey(editableObj, 'unit', e.target.value)}>
                <option value="CR">CR</option>
                <option value="Lakhs">Lakhs</option>
              </select>
            </span>}
          </>
      ) : (
        <>
          <span style={{fontSize: '24px'}} className={`${isValueCurrency ? '' : 'hidden'}`}>{currency ?? "₹"} </span>
          <span style={{fontSize: '24px', paddingLeft: '2%'}}> {value}  {editableObj && editableObj.unit && currency.includes("₹") ? editableObj.unit : ''}</span>
        </>
      )}
    </div>
    <label className={classes['file-handler-label']}>{fileHandlerTitle}</label>
    {isEditable ? (
      <FileHandler
        onUpload={(fileid, fileName) => {
          editableObj[blobKey] = fileid;
          editableObj['file_name'] = fileName;
          editableObj['uploaded_on'] = new Date().toISOString();
        }}
        transporterId={transporterId}
        className={classes['margin-top-0']}
        lastUpdated={editableObj && editableObj.uploaded_on ? editableObj.uploaded_on : '' }
        lastUpdatedClassName={classes['last-updated']}
        lastUpdatedAtBottom
        fileDescription={`${title}_${fileHandlerTitle}`}
        modulename={'Financial Information'}
        screen={ActivityString.GeneralInfo}
        title={title}
        style={{width: '62%'}}
        fileId={editableObj ? editableObj[blobKey] : ''}
        fileName={editableObj ? editableObj['file_name'] : ''}
      />
    ) : (
      <FileHandler
        fileId={fileId}
        fileName={editableObj && editableObj['file_name'] ? editableObj['file_name'] : ''}
        className={classes['margin-top-0']}
        fileViewHeader={fileHandlerTitle}
        lastUpdated={editableObj && editableObj.uploaded_on ? editableObj.uploaded_on : ''}
        lastUpdatedClassName={classes['last-updated']}
        lastUpdatedAtBottom
        fileDescription={`${title}_${fileHandlerTitle}`}
        modulename={'Financial Information'}
        screen={ActivityString.GeneralInfo}
        title={title}
      />
    )}
  </div>
)};

const isValid = (value) => {
  return parseInt(value) >=0 ? true: false
}
export default FinancialInfo;
